import { useCurrentUserContext } from "../contexts/CurrentUserContext";
import { trpc } from "../helpers/trpc";

export const useInitialStatus = () => {
  const { currentUser } = useCurrentUserContext();
  const { data: initialStatus, isLoading } = trpc.getApplicationInitialStatus.useQuery(undefined, {
    enabled: Boolean(currentUser?.id && currentUser?.currentOrganization?.id),
  });

  return {
    loading: isLoading,
    hasTicketing: initialStatus?.hasTicketing,
    hasActiveTicketing: initialStatus?.hasActiveTicketing,
    hasArchivedTicketing: initialStatus?.hasArchivedTicketing,
    hasDonationForm: initialStatus?.hasDonationForm,
    hasActiveDonationForm: initialStatus?.hasActiveDonationForm,
    hasArchivedDonationForm: initialStatus?.hasArchivedDonationForm,
    firstForm: initialStatus?.firstForm,
    latestForm: initialStatus?.latestForm,
  };
};
